const ITEMS = ["Support your people", "Run your club better", "Grow and improve", "Save time", "Reduce costs"];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section data-testid="marquee-section" className="relative bg-ink py-14 md:py-20 overflow-hidden border-y border-white/10">
      <div className="flex w-max animate-marquee whitespace-nowrap will-change-transform">
        {row.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="font-heading text-5xl md:text-7xl font-bold uppercase tracking-tighter text-stroke px-8">
              {item}
            </span>
            <span className="h-3 w-3 rounded-full bg-brand" />
          </div>
        ))}
      </div>
    </section>
  );
};
